import {
  GET_CURRENCY,
  GET_EVENT_PREROLLS,
  GET_PAGE_ID_FOR_URL,
  GET_USER_DATA,
  SPORT_MAP_BY_ALIAS,
  ATTRIBUTES_BY_ALIAS_MAP,
  GROUPED_ATTRIBUTES_BY_ID_MAP_GROUP_ALIAS,
  GET_ATTRIBUTES_CROSS_FILTER,
  GET_CROSS_FILTER_DATA,
  ATTRIBUTES_BY_ID,
  ATTRIBUTES_GROUPS_ALISA_TO_ID_MAP,
  GET_HOME_COMPONENTS,
  GET_ATTRIBUTES_FOR_HOMEPAGE,
  GET_LOCATIONS_FOR_HOMEPAGE,
  GET_PASS_BUILDER,
  GET_SCHEDULE_FILTERS,
  ATTRIBUTES_VALUES_BY_ID,
  GET_CLIPS_TAGS,
  CATEGORY_BY_ID,
  STRIPE,
  USER_SETTINGS,
} from '@/store/getterTypes';
import {
  ATTRIBUTES_CONST_NAME,
  PREROLL,
  STREAM_STATUS,
  TIME,
  URL_QUERIES,
} from '@/const';
import {getStorageItem, setStorageItem, STORAGE_KEYS} from '@/localStorage';

const validCachedPrerollList = () => {
  const now = Date.now();
  return Object.fromEntries(
      Object.entries(getStorageItem(STORAGE_KEYS.DISABLED_PREROLLS) || {})
          .filter(([_, exp]) => {
            return now < exp;
          }),
  );
};

const statusMap = {
  [STREAM_STATUS.vod]: 'for_vod',
  [STREAM_STATUS.live]: 'for_live',
};
export default {
  getChannelRoute(state) {
    const newRoute = [];
    state?.pages?.forEach((page) => {
      newRoute.push({
        path: page.url,
        name: page.name,
        meta: {
          title: page.name,
          scrollToTop: true,
          id: page.id,
        },
        component: () => import(
            /* webpackChunkName: "schedule-view" */ '../../views/CustomPageScreen.vue'),
      });
    });
    return newRoute;
  },
  /**
   * @param {object} state
   * @return {function(string): string|number}
   */
  [GET_PAGE_ID_FOR_URL](state) {
    return (searchUrl) => {
      return state.pages?.find?.(({url, alt_name: alt}) => {
        return url === searchUrl || alt === searchUrl;
      } )?.id;
    };
  },
  [GET_EVENT_PREROLLS]: (state, getters) => (event) => {
    const validList = validCachedPrerollList();
    const allPrerolls = state.settings?.prerolls || [];
    const {
      id: eventId,
      stream_status: eventStatus,
      location_id: eventLocation,
      event_category_id: eventCategory,
    } = event;

    if (!allPrerolls.length) {
      return [];
    }

    const list = [];
    allPrerolls.forEach((preroll) => {
      const {location_id: prerollLocation, event_categories: prerollCategories, id} = preroll;
      let available = preroll[statusMap[eventStatus]];

      if (available && prerollLocation) {
        available = Number(prerollLocation) === Number(eventLocation);
      }
      if (available && prerollCategories?.length) {
        available = prerollCategories.includes(eventCategory);
      }

      if (!available) {
        return;
      }

      const userId = getters[GET_USER_DATA]?.id;
      const prerollKey = `${userId || 'unlogged'}_${eventId}_${id}`;

      if (!Boolean(validList[prerollKey])) {
        list.push({
          ...preroll,
          file: preroll.url,
          onComplete: () => {
            const validList = validCachedPrerollList();
            validList[prerollKey] = Date.now() + (PREROLL.TIME || TIME.HOUR);
            setStorageItem(STORAGE_KEYS.DISABLED_PREROLLS, validList);
          },
        });
      }
    });

    return list.sort((a, b) => b.weight - a.weight);
  },
  [GET_CURRENCY]: (state) => state.settings?.currency || 'USD',
  [SPORT_MAP_BY_ALIAS]: (state) => {
    const sportList = [...state.attributes]
        .find(({name}) => name.toLowerCase() === ATTRIBUTES_CONST_NAME.SPORT);
    if (!sportList) return {};

    return Object.fromEntries(
        sportList.values
            .map((sport) => [sport.value.toLowerCase(), sport]),
    );
  },
  [GET_ATTRIBUTES_FOR_HOMEPAGE]: (state, getters) => {
    const map = {};
    Object.values(getters[ATTRIBUTES_BY_ID]).forEach(({id, alias, values}) => {
      const queryKey = `${URL_QUERIES.ATTR}[${alias.toLowerCase()}]`;
      map[id] = [...values].map((item) => {
        const path = new URL(window.location.origin);
        path.searchParams.set(queryKey, item.value.toLowerCase());

        return {
          id: item.id,
          name: item.title,
          icon: item.image,
          url: path.href.replace(path.origin, ''),
        };
      });
    });
    return map;
  },
  [ATTRIBUTES_BY_ALIAS_MAP]: (state) => {
    const obj = {};
    [...state.attributes].forEach((group) => {
      const groupMap = {};
      group.values.forEach((item) => {
        groupMap[item.value.toLowerCase()] = item;
      });
      obj[group.alias.toLowerCase()] = groupMap;
    });
    return obj;
  },
  [ATTRIBUTES_BY_ID]: (state) => {
    const obj = {};
    [...state.attributes].forEach((group) => {
      obj[group.id] = {
        ...group,
        alias: group.alias.toLowerCase(),
      };
    });
    return obj;
  },
  [ATTRIBUTES_GROUPS_ALISA_TO_ID_MAP]: (state) => {
    const obj = {};
    [...state.attributes].forEach((group) => {
      obj[group.alias.toLowerCase()] = group.id;
    });
    return obj;
  },
  [ATTRIBUTES_VALUES_BY_ID]: (state) => {
    return [...state.attributes].reduce((acc, group) => {
      const {values, ...groupInfo} = group;
      values.forEach((item) => {
        acc[item.id] = {...item, group: groupInfo};
      });
      return acc;
    }, {});
  },
  [GROUPED_ATTRIBUTES_BY_ID_MAP_GROUP_ALIAS]: (state) => {
    const obj = {};
    [...state.attributes].forEach((group) => {
      const groupMap = {};
      group.values.forEach((item) => {
        groupMap[item.id] = item;
      });
      obj[group.alias.toLowerCase()] = groupMap;
    });
    return obj;
  },
  [GET_ATTRIBUTES_CROSS_FILTER]: (state, getters) => {
    const list = getters[GET_CROSS_FILTER_DATA]?.attribute_values || [];
    const groupedMap = getters[GROUPED_ATTRIBUTES_BY_ID_MAP_GROUP_ALIAS];
    const obj = {};

    Object.entries(groupedMap).forEach(([key, values]) => {
      obj[key] = {};
      list.forEach((id) => {
        const item = values[id];
        if (item) {
          obj[key][item.value?.toLowerCase?.()] = item;
        }
      });
    });
    return obj;
  },
  [GET_LOCATIONS_FOR_HOMEPAGE](state) {
    return [...state.eventLocations].map((item) => {
      const path = new URL(window.location.origin);
      path.searchParams.set(URL_QUERIES.location, item.alias.toLowerCase());

      return {
        id: item.id,
        name: item.name,
        icon: item.image,
        url: path.href.replace(path.origin, ''),
      };
    });
  },
  [GET_HOME_COMPONENTS](state) {
    return [...state.ui.homePage];
  },
  [GET_PASS_BUILDER](state) {
    return state.ui.passesPage;
  },
  [GET_SCHEDULE_FILTERS](state) {
    return [...state.ui.scheduleFilters];
  },
  [GET_CLIPS_TAGS]: (state, getters) => ({attributesIds, categoryId} = {}) => {
    const tags = state?.settings?.clipping?.tags;
    if (!tags) return false;
    let res;
    if (attributesIds?.length) {
      for (const id of attributesIds) {
        const attr = getters[ATTRIBUTES_VALUES_BY_ID]?.[id]?.value?.toLowerCase();
        const tag = tags[attr];
        if (tag) {
          res = attr;
          break;
        }
      }
    }
    if (!res && categoryId) {
      const category = getters[CATEGORY_BY_ID]?.[categoryId];
      for (const key of ['alias', 'name']) {
        const name = category?.[key]?.toLowerCase();
        const tag = tags[name];
        if (tag) {
          res = name;
          break;
        }
      }
    }
    return res;
  },
  [STRIPE.TAX_MODE]: (state) => state.settings?.stripe?.stripe_tax_mode,
  [STRIPE.PUBLIC_KEY]: (state) => state.settings?.stripe?.stripe_pk,
  [STRIPE.CONNECTED_ACCOUNT]: (state) => state.settings?.stripe?.connected_account_id,
  [STRIPE.API_VERSION]: (state) => state.settings?.stripe_version,
  [USER_SETTINGS.COLLECT_DATA]: (state) => Boolean(Number(
      state.settings?.['user-settings']?.['disable-collect-user-data'],
  )),
  [USER_SETTINGS.DISABLE_LOGIN]: (state) => Boolean(Number(
      state.settings?.['user-settings']?.['disable-user-login'],
  )),
  [USER_SETTINGS.DISABLE_REGISTRATION]: (state) => Boolean(Number(
      state.settings?.['user-settings']?.['disable-user-registration'],
  )),
};
